<template>
  <div v-if="auth.user.selectedAccess.roleLevel > 0">
    <app-header :title="$store.getters['translations/getLabel']('CHAINS')" />
    <b-container>
      <ChainList />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import ChainList from '@/components/ChainList';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    ChainList,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
    };
  },
  // created() {
  //   this.$store.dispatch('global/getChains');
  // },
};
</script>
